import { ResumeDocument } from '../../types';

export interface ApplyField {
  // i18n/analytics key — maps to resume.fields.<key> for the label.
  key: 'fullName' | 'email' | 'phone' | 'location' | 'website';
  value: string;
}

// Build the list of non-empty contact fields from a resume that are useful to
// paste into an external job application. Order is intentional (most-asked
// first). Returns [] when there's no resume or nothing to copy.
export const buildApplyFields = (
  resume: ResumeDocument | null | undefined
): ApplyField[] => {
  const pi = resume?.personalInfo;
  if (!pi) return [];

  const phone = [pi.phoneCountryCode, pi.phone]
    .map((s) => (s ?? '').trim())
    .filter(Boolean)
    .join(' ')
    .trim();

  const candidates: ApplyField[] = [
    { key: 'fullName', value: (pi.fullName ?? '').trim() },
    { key: 'email', value: (pi.email ?? '').trim() },
    { key: 'phone', value: phone },
    { key: 'location', value: (pi.location ?? '').trim() },
    { key: 'website', value: (pi.website ?? '').trim() },
  ];

  return candidates.filter((f) => f.value.length > 0);
};

// Add dummy default export for Expo Router (every file under app/ needs one).
export default { buildApplyFields };
